<template>
    <rkm-modal
        :loading="loading"
        large
        ref="Modal"
        persistent
        title="Permissões"
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Unidade"
                    :value="centroCusto.unidadeNomeFantasia"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Local de atendimento"
                    :value="centroCusto.localAtendimentoNome"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    label="Setor"
                    :value="centroCusto.setorNome"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-area title="Grupos">
            <rkm-table
                :fields="fields"
                :items="grupos"
                @filtered="gruposFiltered = $event"
                sort-by="nome"
            >
                <template #head(permiteControlar)>
                    <rkm-form-checkbox
                        :disabled="disabledSelectAll"
                        :indeterminate="indeterminate"
                        :value="true"
                        @change="onChangeSelectAll"
                        v-model="selectedAll"
                    />
                </template>

                <template v-slot:cell(quantidadeSubgruposPermitidos)="{ item }">
                    {{ item.subgrupos.filter(sg => sg.permiteControlar).length }}/{{ item.subgrupos.length }}
                </template>

                <template v-slot:cell(permiteControlar)="{ item }">
                    <rkm-form-checkbox
                        :value="true"
                        @change="onChangePermissao(item, $event)"
                        v-model="item.permiteControlar"                        
                    />
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="$refs.ModalSubgrupo.open(item)"
                        color="primary"
                        :disabled="item.subgrupos.length == 0"
                        small
                        :title="item.subgrupos.length == 0 ? 'Este grupo não possui subgrupos' : 'Configurar permissões de subgrupos'"
                    >
                        <rkm-icon icon="cog" />
                    </rkm-button>

                    <rkm-button
                        @click="configurarItens(item)"
                        :disabled="!item.permiteControlar"
                        color="primary"                        
                        small
                        :title="'Configurar itens'"
                    >
                        <rkm-icon icon="list" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>

        <ModalSubgrupo ref="ModalSubgrupo" />
        <ModalItem ref="ModalItem" />
    </rkm-modal>
</template>

<script>
// Components
import ModalSubgrupo from './components/subgrupo/Modal'
import ModalItem from './components/item/Modal'

// Vuex.
import { mapGetters } from 'vuex'

// Others.
import { object, repository } from '@/mixins'

export default {
    components: { ModalSubgrupo, ModalItem },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'permiteControlar',
                    class: 'col-min text-center'
                },
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                },
                {
                    key: 'quantidadeSubgruposPermitidos',
                    label: 'Subgrupos permitidos',
                    class: 'col-min text-center'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
        disabledSelectAll() {

            return !this.grupos
                .filter(g => this.gruposFiltered.find(gf => gf.id === g.id))
                .find(g => !g.hasPermissaoRequisicao)
        }
    },
    data: () => ({
        centroCusto: {},
        grupos: [],
        gruposFiltered: [],
        indeterminate: false,
        selectedAll: false,
    }),
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('almoxarifado.parametrizacao')
        }
    },
    methods: {
        open(centroCusto) {

            this.centroCusto = centroCusto
            this.grupos = this.clone(centroCusto.grupos)
            this.gruposFiltered = this.clone(this.grupos)

            this.$refs.Modal.show()
        },
        configurarItens(item) {

            if (item.materiais && item.materiais.length > 0) {

                this.$refs.ModalItem.open(item)

                return;
            }

            this.repositories.parametrizacao.list({
                origem: 'portal-divulgacao',
                listar: 'item-grupos',
                grupo_id: item.id,
                centro_custo_id: item.centroCustoId,
            })
                .then(({ data }) => {

                    item.materiais = data.materiais

                    this.$refs.ModalItem.open(item)
                })
                .catch(this.handleError)
                .finally()
        },
        onChangeSelectAll(permitido) {

            if (permitido) {

                const gruposFiltered = this.grupos
                    .filter(g => this.gruposFiltered.find(gf => gf.id === g.id))

                if (gruposFiltered.find(g => g.subgrupos.length > 0)) {

                    this.showConfirmation(
                        'Deseja conceder permissão para todos os subgrupos?',
                        async () => this.selectAll(true),
                        async () => this.selectAll(false)
                    )
                }
                else {

                    this.selectAll(false)
                }

                return
            }

            this.unselectAll()
        },
        selectAll(checkSubgrupos) {

            this.grupos
                .filter(g => this.gruposFiltered.find(gf => gf.id === g.id))
                .map(grupo => {

                    grupo.permiteControlar = true

                    if (checkSubgrupos) {

                        grupo.subgrupos.map(sg => sg.permiteControlar = true)
                    }
                })
        },
        unselectAll() {

            this.grupos
                .filter(g => this.gruposFiltered.find(gf => gf.id === g.id))
                .filter(g => !g.hasPermissaoRequisicao)
                .map(grupo => {

                    grupo.permiteControlar = false
                    grupo.subgrupos.map(sg => sg.permiteControlar = false)
                })
        },
        onChangePermissao(item, permitido) {

            if (permitido && item.subgrupos.length > 0) {

                this.showConfirmation(
                    'Deseja conceder permissão para todos os subgrupos?',
                    async () => item.subgrupos.map(sg => sg.permiteControlar = true)
                )

                return
            }

            item.subgrupos.map(sg => sg.permiteControlar = false)
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        save() {

            this.centroCusto.grupos = this.clone(this.grupos)

            this.$refs.Modal.hide()
        },
        handleSelectAllStatus() {

            this.indeterminate = false

            const gruposFiltered = this.grupos
                .filter(g => this.gruposFiltered.find(gf => gf.id === g.id))

            const quantidadePermitida = gruposFiltered.filter(g => g.permiteControlar).length

            this.selectedAll = quantidadePermitida > 0 && quantidadePermitida == gruposFiltered.length

            if (quantidadePermitida > 0 && quantidadePermitida != gruposFiltered.length) {

                this.indeterminate = true
            }
        }
    },
    mixins: [object, repository],
    watch: {
        grupos: {
            deep: true,
            handler() {

                this.handleSelectAllStatus()
            }
        },
        gruposFiltered() {

            this.handleSelectAllStatus()
        }
    }
}
</script>